module.exports = __webpack_public_path__ + "img/etc-checkbox-selected.f60aaa61.svg";